import { render, staticRenderFns } from "./statistics-main-visits.vue?vue&type=template&id=b614d0b0"
import script from "./statistics-main-visits.vue?vue&type=script&lang=js"
export * from "./statistics-main-visits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports